import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { TextInput } from '@/scopes/common/components/FormElements/TextInput'
import styles from '../Form.module.css'

export function StreetNumberAdditionalInput({
  name,
  required,
  pattern,
}: {
  name: string
  pattern?: string
  required?: boolean
}) {
  const intl = useIntl()
  useTrackFieldValidation(name)

  return (
    <TextInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_street_number_additional' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_street_number_additional' })}
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldXS)}
      pattern={pattern}
      patternErrorMessage={
        intl.formatMessage({ id: 'checkout_steps_participants_form_field_pattern_error_message_street_number_additional' })
      }
    />
  )
}
